import React from 'react'
import clsx from 'clsx'

// A section heading: the H2 in Instrument Serif, and at most one line of
// grey intro under it. Headings are never centred except inside a
// `<Section centred>` (the final CTA).
//
//   <SectionHeading intro="Nine in ten bookings are one of these.">
//     Three washes cover almost everyone
//   </SectionHeading>
export const SectionHeading = ({ intro, as: Tag = 'h2', className, children }) => (
  <div className={clsx('gwmc-heading-block', className)}>
    <Tag className="gwmc-h2">{children}</Tag>
    {intro && <p className="gwmc-intro">{intro}</p>}
  </div>
)
